import React from 'react'
import PropTypes from 'prop-types'

/**
 * Circular progress indicator component
 * @param {number} percentage - Progress percentage (0-100)
 * @param {number} [size=60] - Size of the circle in pixels
 * @param {number} [strokeWidth=4] - Width of the progress stroke
 * @param {string} [color='#4CAF50'] - Color of the progress stroke
 * @returns {Element}
 */
export default function CircularProgress ({
  percentage,
  size = 60,
  strokeWidth = 4,
  color = '#4CAF50'
}) {
  const radius = (size - strokeWidth) / 2
  const circumference = radius * 2 * Math.PI
  const offset = circumference - (percentage / 100) * circumference

  return (
    <svg
      width={size}
      height={size}
      style={{ transform: 'rotate(-90deg)' }}
    >
      {/* Background circle */}
      <circle
        cx={size / 2}
        cy={size / 2}
        r={radius}
        fill='none'
        stroke='#e0e0e0'
        strokeWidth={strokeWidth}
      />
      {/* Progress circle */}
      <circle
        cx={size / 2}
        cy={size / 2}
        r={radius}
        fill='none'
        stroke={color}
        strokeWidth={strokeWidth}
        strokeDasharray={circumference}
        strokeDashoffset={offset}
        strokeLinecap='round'
        style={{
          transition: 'stroke-dashoffset 0.5s ease'
        }}
      />
      {/* Percentage text */}
      <text
        x='50%'
        y='50%'
        textAnchor='middle'
        dy='0.3em'
        fill='currentColor'
        fontSize={size / 4.5}
        fontWeight='bold'
        style={{ transform: 'rotate(90deg)', transformOrigin: 'center' }}
      >
        {Math.round(percentage)}%
      </text>
    </svg>
  )
}

CircularProgress.propTypes = {
  percentage: PropTypes.number.isRequired,
  size: PropTypes.number,
  strokeWidth: PropTypes.number,
  color: PropTypes.string
}
